import React, { createContext, useState, useContext, useMemo } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { blueGrey } from '@mui/material/colors';

const ThemeContext = createContext();

export const ThemeProviderWrapper = ({ children }) => {
  const [mode, setMode] = useState('light');

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          primary: {
            main: "#235789",
          },
          secondary: blueGrey,
          mode,
          ...(mode === 'light'
            ? {
                background: {
                  default: '#ffffff',
                  paper: '#ffffff',
                }
              }
            : {
                background: {
                  default: '#262626',
                  paper: '#262626',
                }
              }),
        },
        typography: {
          fontFamily: 'Poppins, serif',
        },
      }),
    [mode]
  );

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);
